(() => {
  const setLocalizedCartLabel = () => {
    if (!window.btyStrings || !window.btyStrings.product) return;
    const isGerman = document.documentElement.lang.toLowerCase().startsWith('de');
    window.btyStrings.product.add_to_cart = isGerman ? 'In den Warenkorb' : 'Add to cart';
  };

  const initTabs = (root = document) => {
    root.querySelectorAll('[data-bioyon-product-tabs]').forEach((tabs) => {
      if (tabs.dataset.bioyonTabsInitialized === 'true') return;
      tabs.dataset.bioyonTabsInitialized = 'true';

      const buttons = Array.from(tabs.querySelectorAll('[role="tab"][data-tab]'));
      const panels = Array.from(tabs.querySelectorAll('[role="tabpanel"][data-panel]'));

      const activate = (button, focus = false) => {
        const target = button.dataset.tab;

        buttons.forEach((item) => {
          const active = item === button;
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-selected', active ? 'true' : 'false');
          item.tabIndex = active ? 0 : -1;
        });

        panels.forEach((panel) => {
          const active = panel.dataset.panel === target;
          panel.classList.toggle('is-active', active);
          panel.hidden = !active;
        });

        if (focus) button.focus();
      };

      buttons.forEach((button, index) => {
        button.addEventListener('click', () => activate(button));
        button.addEventListener('keydown', (event) => {
          let nextIndex = index;
          if (event.key === 'ArrowRight') nextIndex = (index + 1) % buttons.length;
          if (event.key === 'ArrowLeft') nextIndex = (index - 1 + buttons.length) % buttons.length;
          if (event.key === 'Home') nextIndex = 0;
          if (event.key === 'End') nextIndex = buttons.length - 1;
          if (nextIndex === index) return;
          event.preventDefault();
          activate(buttons[nextIndex], true);
        });
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
  setLocalizedCartLabel();
      initTabs();
    });
  } else {
        setLocalizedCartLabel();
    initTabs();
  }

  document.addEventListener('shopify:section:load', (event) => initTabs(event.target));
})();
